module.exports = __webpack_public_path__ + "img/robot-outline-active.0e7f3719.svg";